const Gemini = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9553_8602)">
    <path d="M12 24C11.5426 20.9809 10.131 18.1874 7.97184 16.0282C5.81264 13.869 3.01912 12.4574 0 12C3.01912 11.5426 5.81264 10.131 7.97184 7.97184C10.131 5.81264 11.5426 3.01912 12 0C12.4575 3.01906 13.8692 5.81249 16.0283 7.97167C18.1875 10.1308 20.9809 11.5425 24 12C20.9809 12.4575 18.1875 13.8692 16.0283 16.0283C13.8692 18.1875 12.4575 20.9809 12 24Z" fill="url(#paint0_linear_9553_8602)"/>
    </g>
    <defs>
    <linearGradient id="paint0_linear_9553_8602" x1="-5.28187e-05" y1="2400" x2="1649.52" y2="729.48" gradientUnits="userSpaceOnUse">
    <stop stop-color="#1C7DFF"/>
    <stop offset="0.52021" stop-color="#1C69FF"/>
    <stop offset="1" stop-color="#F0DCD6"/>
    </linearGradient>
    <clipPath id="clip0_9553_8602">
    <rect width="24" height="24" fill="white"/>
    </clipPath>
    </defs>
    </svg>
    
  )
}

export default Gemini